export default {
  brandingCodes: [],
  brandingCode: undefined,
};
